import axios from "axios";

export const getEasyshipAccount = async (apikey) => {
  const options = {
    method: "GET",
    headers: {
      accept: "application/json",
      authorization: `Bearer ${apikey}`,
    },
  };
  try {
    const response = await fetch(
      "https://api.easyship.com/2023-01/account",
      options
    );
    const response_1 = await response.json();
    // console.log(response_1);
    return response_1;
  } catch (err) {
    console.error(err);
    return err;
  }
};
export const getItemCategories = async (apikey) => {
  const options = {
    method: "GET",
    headers: {
      accept: "application/json",
      authorization: `Bearer prod_jF/0wVh8rumMKWUjqm1ZY4RyX/xsFkJedn8dj61UhtY=`,
    },
  };
  try {
    const response = await fetch(
      "https://public-api.easyship.com/2024-09/item_categories",
      options
    );
    const response_1 = await response.json();
    // console.log(response_1);
    return response_1;
  } catch (err) {
    console.error(err);
    return err;
  }
};
export const getCountries = async (apikey) => {
  const options = {
    method: "GET",
    headers: {
      accept: "application/json",
      authorization: `Bearer prod_jF/0wVh8rumMKWUjqm1ZY4RyX/xsFkJedn8dj61UhtY=`,
    },
  };
  try {
    const response = await fetch(
      "https://public-api.easyship.com/2024-09/countries",
      options
    );
    const response_1 = await response.json();
    // console.log(response_1);
    return response_1;
  } catch (err) {
    console.error(err);
    return err;
  }
};

export const getShippingQuotes = async (payload) => {
  const options = {
    method: "POST",
    headers: {
      accept: "application/json",
      authorization: `Bearer prod_jF/0wVh8rumMKWUjqm1ZY4RyX/xsFkJedn8dj61UhtY=`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  };
  try {
    const response = await fetch(
      "https://public-api.easyship.com/2024-09/rates",
      options
    );
    const response_1 = await response.json();
    // console.log(response_1);
    return response_1;
  } catch (err) {
    console.error(err);
    return err;
  }
}

export const getAllCourier = async (apikey, umbrella_name, country = "") => {
  const options = {
    method: "GET",
    headers: {
      accept: "application/json",
      authorization: `Bearer ${apikey}`,
    },
  };
  try {
    const response = await fetch(
      `https://public-api.easyship.com/2024-09/courier_services?umbrella_name=${umbrella_name}&page=1&per_page=100`,
      options
    );
    const response_1 = await response.json();
    // console.log(response_1);
    return response_1;
  } catch (err) {
    console.error(err);
    return err;
  }
};

export const getShipmentDetails = async (apikey, shipmentId) => {
  const options = {
    method: "GET",
    headers: {
      accept: "application/json",
      authorization: `Bearer ${apikey||"prod_jF/0wVh8rumMKWUjqm1ZY4RyX/xsFkJedn8dj61UhtY="}`,
    },
  };
  try {
    const response = await fetch(
      `https://public-api.easyship.com/2024-09/shipments/${shipmentId}?format=URL&label=A4&commercial_invoice=A4&packing_slip=A4`,
      options
    );
    const response_1 = await response.json();
    // console.log(response_1);
    return response_1;
  } catch (err) {
    console.error(err);
    return err;
  }
};

export const createWebhook = async (apikey) => {
  try {
    const response = await axios.post(
      "https://public-api.easyship.com/2024-09/webhooks",
      {
        event_types: [
          "shipment_tracking_status_changed",
          "shipment_label_created",
        ],
        version: "2023-01",
        endpoint:
          "https://us-central1-postpaldev-b0be2.cloudfunctions.net/easyShipWebHookStatus",
      },
      {
        headers: {
          accept: "application/json",
          authorization: `Bearer ${apikey}`,
        },
      }
    );
    console.log(response);
    return response;
  } catch (err) {
    console.error(err);
    return err;
  }
};

export const activateWebhook = async (webhookId,apikey) => {
  try{
    const response = await axios.post(
      `https://public-api.easyship.com/2024-09/webhooks/${webhookId}/activate`,
      {},
      {
        headers: {
          accept: "application/json",
          authorization: `Bearer ${apikey}`,
        },
      }
    );
    console.log(response);
    return response;
  }catch(err){
    console.log(err);
    return err;
  }
}